export default __webpack_public_path__ + "static/BIANCA_OG_IMAGE-5fbcf8c29c21ec717a69b3d10c6da9a7.png";